import Keycloak from "keycloak-js";
import { dataunityBase } from "src/utils/properties/UrlsAndEnvProperties";


const keycloak = new Keycloak({
    url: "https://auth.fdu-qa.honeywell.com",
    realm: "hcrealm",
    clientId: "react-with-keycloak-client",
});

export const DATA_UNITY_BASE = dataunityBase();
export const RBAC_BASE = "https://rbac.fdu-dev.honeywell.com/apps/101/"


export default keycloak;